import { render } from "./UniqueAsYou.vue?vue&type=template&id=1368eece&scoped=true&ts=true"
import script from "./UniqueAsYou.vue?vue&type=script&lang=ts"
export * from "./UniqueAsYou.vue?vue&type=script&lang=ts"

import "./UniqueAsYou.vue?vue&type=style&index=0&id=1368eece&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1368eece"]])

export default __exports__